import React from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import BeaconDropdownMetricColumnChart from 'src/components/BeaconV2Components/BeaconMetricColumnChart/BeaconDropdownMetricColumnChart';
import TopEntityChartV2Loading from 'src/components/BeaconV2Components/TopEntityChartV2/TopEntityChartV2Loading';
import { useMainEntityType } from 'src/utils/Hooks/reduxSelectors';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import ProductsWithRetailSalesSplineChart from 'src/components/BeaconV2Components/ExperimentalLayout/Sales/ProductsWithRetailSalesSplineChart';
import RetailSalesProductsList from 'src/components/BeaconV2Components/ExperimentalLayout/Summary/Sales/RetailSales/RetailSalesProductsList';

import { BeaconSplineChartWithPromotionsWrapper } from 'src/components/BeaconV2Components/ExperimentalLayout/Prices/Promotions/BeaconSplineChartWithPromotions';

/**
 * Shows the data for the retail sales page on the Sales tab
 */

const RetailSalesPage = () => {
  const entityType = useMainEntityType();

  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        <BeaconSplineChartWithPromotionsWrapper indexName="sales" fieldName="retailSales" />
        <BeaconSplineChartWithPromotionsWrapper indexName="sales" fieldName="wholesaleSales" />
        <BeaconDropdownMetricColumnChart
          beaconChartWithLegendPropsBuilder={(props) => ({
            ...props,
            loadingComponent: <TopEntityChartV2Loading />
          })}
          indexName="sales"
          fieldName="retailSales"
          dropdownOptions={[
            {
              id: 'subCategoryId',
              label: 'Subcategory'
            },
            {
              id: 'categoryId',
              label: 'Category'
            },
            {
              id: 'brandId',
              label: 'Brand'
            }
          ].filter((option) => !option.id.toLowerCase().startsWith(entityType))}
          titlePrefix="Retail Sales by"
        />
        {entityType !== 'product' && <ProductsWithRetailSalesSplineChart />}
        <RetailSalesProductsList />
      </Flex>
    </BasePageContainer>
  );
};

export default RetailSalesPage;
